import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {


  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit() {
    this.addCustomScript();
  }

  addCustomScript() {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
    !async function(){try{let e="7b5dedb2-c0be-4eb4-94d8-0fe44a00a961",w="api.sms-magic.com",a="https://app.sms-magic.com",o="",n="",c="",i=3e3,d="https://tenali.sms-magic.com";async function t(){o=a+"/v1/conversive/button/run/"+e+"?latitude="+n+"&longitude="+c;let t=await fetch(o).then((t=>t.json())).then((t=>t)).catch((t=>{}));if("success"===t.response.status){let e=t.response;if(document.getElementById(e.data.button_config.scriptLocation))displayButton(e.data);else{const t=document.getElementsByTagName("head")[0],a=document.createElement("link"),o=document.createElement("script"),n=document.createElement("link"),c=document.createElement("script");a.rel="stylesheet",a.type="text/css",a.href=e.data.button_config.cssLocation,a.onload=()=>{t.appendChild(o)},t.appendChild(a),o.type="text/javascript",o.id=e.data.button_config.scriptLocation,o.src=e.data.button_config.scriptLocation,o.onload=()=>{displayButton(e.data)},n.rel="stylesheet",n.type="text/css",c.id=e.data.chatbot_config.chatbotCSS,n.href=e.data.chatbot_config.chatbotCSS,n.onload=()=>{t.appendChild(c)},t.appendChild(n),c.type="text/javascript",c.id=e.data.chatbot_config.chatbotJS,c.src=e.data.chatbot_config.chatbotJS,c.onload=()=>{loadChatBot(d,w,e.data)}}}}navigator.geolocation&&navigator.geolocation.getCurrentPosition((e=>{n=e.coords.latitude,c=e.coords.longitude,t()}),(e=>{t()}),{timeout:i}),setTimeout(t,i)}catch(s){}}();
    `;
    this.renderer.appendChild(this.el.nativeElement, script);
  }
  clearCookiesAndLocalStorage() {
    // Clear local storage
    localStorage.clear();

    // Clear cookies
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        location.reload();
  
    }
  }
  
}
